import { ORDERED_CRM_STATUS } from '@/constants';

export const isStatusBefore = (status, referenceStatus) => {
  const targetIndex = ORDERED_CRM_STATUS.indexOf(referenceStatus);
  const currentIndex = ORDERED_CRM_STATUS.indexOf(status);
  return currentIndex !== -1 && currentIndex < targetIndex;
};
